/* @flow */

import * as types from 'src/shared/domain/topic/action/topicActionTypes';
import {
  createReducer,
  setRequestResult,
  setFetchingState,
  unsetFetchingState,
} from 'src/shared/core/util/reducerUtils';

const initialState = {
  result: [],
  isFetching: false,
};

export default createReducer(initialState, {
  [types.SIMULATE_TOPICS_FETCH]: setFetchingState,
  [types.FETCH_TOPICS_REQUEST]: setFetchingState,
  [types.FETCH_TOPICS_SUCCESS]: setRequestResult,
  [types.FETCH_TOPICS_FAILURE]: unsetFetchingState,
});
